import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=2b4ad19c&"
import script from "./FormItem.vue?vue&type=script&lang=js&"
export * from "./FormItem.vue?vue&type=script&lang=js&"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=2b4ad19c&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4ad19c')) {
      api.createRecord('2b4ad19c', component.options)
    } else {
      api.reload('2b4ad19c', component.options)
    }
    module.hot.accept("./FormItem.vue?vue&type=template&id=2b4ad19c&", function () {
      api.rerender('2b4ad19c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Waste/FormItem.vue"
export default component.exports